import React from 'react';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import GlobalTooltip from 'components/GlobalTooltip';

function CreateCourtEvent(props) {
  const { rowData } = props;
  const { handleShowCreateEvent } = useFileManagerContext();

  const handleCourtEvent = (rowData) => {
    const data = {
      file_path: rowData?.file_path,
      file_name: rowData?.file_name,
      sk: rowData?.sk,
    };
    handleShowCreateEvent(rowData, data);
  };

  return (
    <>
      <span role="button">
        <GlobalTooltip tooltip="Create Event" className="text-primary-main d-flex align-items-center" position="top">
          <span className="bi bi-calendar4-week F-size12" onClick={() => handleCourtEvent(rowData)} aria-hidden="true" />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default CreateCourtEvent;
